import React from "react";

import PageLayout from "../../components/PageLayout";
import Card from "../../components/Card";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

const reasonToWords = {
  disabled: {
    title: "We’re at capacity right now",
    limitMessage:
      "We take on a limited number of new cases so that every client gets the attention they deserve. We’re adding more capacity as fast as we can, but we’ve reached our current limit.",
    tryAgainMessage: "Please do check back — we open up new spaces regularly.",
  },
  daily_quota_exceeded: {
    title: "We’ve reached today’s capacity",
    limitMessage:
      "We take on a limited number of new cases each day so that every client gets the attention they deserve. We’re adding more capacity as fast as we can, but we’ve reached today’s limit.",
    tryAgainMessage: "We’d love to help you — please try again from 9am tomorrow, when new spaces open up.",
  },
  weekly_quota_exceeded: {
    title: "We’ve reached this week’s capacity",
    limitMessage:
      "We take on a limited number of new cases each week so that every client gets the attention they deserve. We’re adding more capacity as fast as we can, but we’ve reached this week’s limit.",
    tryAgainMessage: "We’d love to help you — please try again from 9am on Monday, when new spaces open up.",
  },
};

const SignupTemporarilySuspended = (props) => {
  let words;
  if (props.reason) {
    words = reasonToWords[props.reason];
  }
  if (!words) {
    words = reasonToWords.disabled;
  }

  return (
    <PageLayout>
      <Card title={words.title} removeTopPadding>
        <p>Thanks for choosing Juno for your conveyancing!</p>
        <p>{words.limitMessage}</p>
        <p>
          <strong>Unfortunately, that means we can’t take your case on just yet</strong> — and we’re genuinely sorry
          about that.
        </p>
        <p>{words.tryAgainMessage}</p>
        <p>Thank you for bearing with us — we hope to help you with your move soon.</p>
      </Card>
      <Image src={imageOfficeWorking} fullWidth />
    </PageLayout>
  );
};

export default SignupTemporarilySuspended;
